import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getTipoDocumento, cadastrarTipoDocumento, alterarTipoDocumento, excluirTipoDocumento } from './tipos_documentos_service';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
export var TiposDocumentosEditar = function () {
    var services = {
        getItem: getTipoDocumento,
        cadastrarItem: cadastrarTipoDocumento,
        alterarItem: alterarTipoDocumento,
        excluirItem: excluirTipoDocumento,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.TIPOS_DOCUMENTOS, paginaPermissao: FUNCIONALIDADES.TIPOS_DOCUMENTOS, rota: ROUTES.TIPOS_DOCUMENTOS, services: services });
};
export default TiposDocumentosEditar;
